import React, { useEffect } from 'react';
import { useCollectionStepper } from 'Hooks/useCollectionStepper';
import { useLayoutContext } from 'Context/LayoutContext';
import {
  RoadmapDeliverableWrapperLayout,
} from '../../../Wrapper/RoadmapDeliverableWrapperLayout';
import {
  GoalDetailOutcomesSelectorContent,
} from './GoalDetailOutcomesSelectorContent';

const RoadmapDeliverableGoalDetailOutcomesSelector = ({ collection }) => {
  const {
    resource,
    next,
    previous,
    isStart,
    isEnd,
    setIndex,
  } = useCollectionStepper(collection);
  const { setNavigationVisible } = useLayoutContext();

  useEffect(() => {
    setNavigationVisible(false);
  }, [setNavigationVisible]);

  // Only override back if we are not at the start
  const handleBack = isStart ? undefined : previous;

  // Only override next if we are not at the end
  const handleNext = isEnd ? undefined : next;

  return (
    <RoadmapDeliverableWrapperLayout
      handleNextOverride={handleNext}
      handlePreviousOverride={handleBack}
      primaryActionLabelOverride={resource.attr('primaryActionLabel')}
    >
      <GoalDetailOutcomesSelectorContent collection={collection} resource={resource} setIndex={setIndex} />
    </RoadmapDeliverableWrapperLayout>

  );
};

RoadmapDeliverableGoalDetailOutcomesSelector.propTypes = {};

export { RoadmapDeliverableGoalDetailOutcomesSelector };
